export enum EventTypes {
  DragStart = 'dragstart',
  DragEnter = 'dragenter',
  DragOver = 'dragover',
  DragLeave = 'dragleave',
  DragEnd = 'dragend',
  Drag = 'drag',
  Drop = 'drop'
}
